<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 10.979,7.449c-0.722-0.685-1.776-0.887-2.7-0.517c-0.912,0.351-1.518,1.223-1.529,2.2v2.591 c0.049,2.686,2.264,4.824,4.95,4.777h6.425c0.328,0.012,0.604-0.243,0.616-0.571c0.006-0.167-0.058-0.33-0.178-0.447L10.979,7.449z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 4.5,9.75h2.25 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 9.375,9.75c0.207,0,0.375,0.168,0.375,0.375 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 9,10.125C9,9.918,9.168,9.75,9.375,9.75 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 9.375,10.5 C9.168,10.5,9,10.332,9,10.125 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 9.75,10.125c0,0.207-0.168,0.375-0.375,0.375 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 12,0.75c6.213,0,11.25,5.037,11.25,11.25 S18.213,23.25,12,23.25S0.75,18.213,0.75,12S5.787,0.75,12,0.75z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
      v-if="settings.circle"
    />
    <path
      d="M 12.75,16.5v2.25"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconWaldigLogo",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {
    circle() {
      return this.settings.circle !== undefined ? this.settings.circle : true;
    }
  }
};
</script>